import { render, staticRenderFns } from "./BasicBackgroundHeroSection.vue?vue&type=template&id=7ca93bb0&scoped=true&"
import script from "./BasicBackgroundHeroSection.vue?vue&type=script&lang=js&"
export * from "./BasicBackgroundHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicBackgroundHeroSection.vue?vue&type=style&index=0&id=7ca93bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca93bb0",
  null
  
)

export default component.exports